(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oc-foam-pattern-promo"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('[data-foam-compare]').forEach(box=>{if(box.dataset.ready)return;box.dataset.ready='true';const input=box.querySelector('input');const sync=()=>box.style.setProperty('--reveal',input.value+'%');input.addEventListener('input',sync);let active=null;const move=e=>{const r=box.getBoundingClientRect();input.value=Math.round(Math.max(0,Math.min(100,(e.clientX-r.left)/r.width*100)));sync()};input.addEventListener('pointerdown',e=>{if(e.button!==0)return;active=e.pointerId;input.setPointerCapture(active);input.focus({preventScroll:true});move(e);e.preventDefault()});input.addEventListener('pointermove',e=>{if(active===e.pointerId)move(e)});const end=()=>{active=null};input.addEventListener('pointerup',end);input.addEventListener('pointercancel',end);input.addEventListener('lostpointercapture',end);sync()})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();
})();
